<template xmlns:v-on="http://www.w3.org/1999/xhtml">
<div>
  <headlink></headlink>
  <div class="container ui-flex ui-flex-pack-center">
             
    <div class="right-container ui-center 	" >
      <ul class="ul-li-list " >
        <li  class="ui-border-b ui-flex  ui-flex-align-center ui-flex-pack-center">
          权限分配    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button type="button" class="btn btn-primary" v-on:click="add()">添加</button>
          
        </li>
      </ul>
    
      <ul class="ul-li-list " >
      
          <p>
          	<input type="checkbox"   class="lv" name="shebei"  value="r001" />
          	设备控制</p>
          	<hr>
          	 <p>
          	<input type="checkbox"   class="lv" name="shebei"  value="r002" />
          	地图位置</p>
          	<hr>
          	 <p>
          	<input type="checkbox"   class="lv" name="shebei"  value="r005" />
          	消息记录</p>
          	<hr>
          	 <p>
          	<input type="checkbox"   class="lv" name="shebei"  value="r007" />
          	修改设备名称</p>
          	<hr>
          	 <p>
          	<input type="checkbox"   class="lv" name="shebei"  value="r008" />
          	掉电记忆设置</p>
          	<hr>
          	 <p>
          	<input type="checkbox"   class="lv" name="shebei"  value="r009" />
          	端口报警提示设置</p>
          	<hr>
          	<p>
          	<input type="checkbox"   class="lv" name="shebei"  value="r010" />
          	停电来电报警设置</p>
      
      </ul>
      
    </div>
  </div>
 
</div>
</template>

<script>
import headlink from '@/components/common/headlink'

export default {
  name: 'quanxian',
  data () {
    return {
    	alertFlag:false
    }
  },
  methods:{

  	
   add :function(){
   	   var uid=this.$route.params.uId;
   	  console.log("ok");
   
   	  var qxgl = new Array();
			$.each($('input[name="shebei"]:checked'), function() {
          var ZyUserAuth = new Object();
                                 ZyUserAuth.uId=uid;
                                 ZyUserAuth.rId=$(this).val();
                                 ZyUserAuth.rName='';
                              qxgl.push(ZyUserAuth);
});
		        
    	   					function zqdsData (){
    var json = {
    	         "serviceCode": "1030",
            		'userId':uid,
            		'authList': qxgl
								}
									return json;
		}
				
		  $.ajax({
		    	       type: "post",
									url: "http://59.110.64.112:8080/ZYun/HttpService.do",
									contentType: "application/json; charset=utf-8",
									async: true,
									data: JSON.stringify(zqdsData()),
									dataType: 'json',
									success: function(e) {
										if("0000" == e.respCode) {
									     jeBox.msg('成功！', {
												icon: 2,
												time: 3
											});
              
									}else{
										jeBox.msg('失败！'+e.respMsg, {
												icon: 3,
												time: 3
											});
									}
										
								}
			
			
	})
			
		
		
		
		
			

 }
  },
 
  components: {
    headlink:headlink
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css" >
</style>



// WEBPACK FOOTER //
// src/components/userManage/quanxian.vue